import { useTheme } from '@emotion/react';
import { Button, Dialog, DialogActions, IconButton, Stack, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useRef } from 'react';
import { useDispatch } from 'react-redux';
import ClearIcon from '@mui/icons-material/Clear';
import { buttonStyle2, dialogButtonCancel } from '../../../../utils/commonStyle';
import DoneIcon from '@mui/icons-material/Done';
import { CancelToken } from 'apisauce';
import appapi from '../../../../api/apiClient';
import { useEffect } from 'react';
import moment from 'moment';
import AddNoonReport from './AddNoonReport';
import ActivityIndicator from '../../../../components/DataTable/ActivityIndicator';
import { useTranslation } from 'react-i18next';

const sx = {
  '& .MuiDialog-container': {
    alignItems: 'center',
    WebkitAlignItems: 'center',
    WebkitBoxAlign: 'center',
  },
  '& .MuiPaper-root': {
    width: '100%',
    margin: '8px',
    borderRadius: '4px',
    // maxWidth: '736px',
    height: '100%',
    maxWidth: '100%',
    maxHeight: '90%',
  },
};

const oilConsumption = [
  {
    fuel: 'HFO',
    mass: '2380.78 mt',
    sfoc: '2,367 g/kwh',
    cv: '34,589 kcl/kg',
  },
  {
    fuel: 'HFO',
    mass: '2380.78 mt',
    sfoc: '2,367 g/kwh',
    cv: '34,589 kcl/kg',
  },
  {
    fuel: 'HFO',
    mass: '2380.78 mt',
    sfoc: '2,367 g/kwh',
    cv: '34,589 kcl/kg',
  },
  {
    fuel: 'HFO',
    mass: '2380.78 mt',
    sfoc: '2,367 g/kwh',
    cv: '34,589 kcl/kg',
  },
  {
    fuel: 'HFO',
    mass: '2380.78 mt',
    sfoc: '2,367 g/kwh',
    cv: '34,589 kcl/kg',
  },
  {
    fuel: 'HFO',
    mass: '2380.78 mt',
    sfoc: '2,367 g/kwh',
    cv: '34,589 kcl/kg',
  },
  {
    fuel: 'HFO',
    mass: '2380.78 mt',
    sfoc: '2,367 g/kwh',
    cv: '34,589 kcl/kg',
  },
  {
    fuel: 'HFO',
    mass: '2380.78 mt',
    sfoc: '2,367 g/kwh',
    cv: '34,589 kcl/kg',
  },
  {
    fuel: 'HFO',
    mass: '2380.78 mt',
    sfoc: '2,367 g/kwh',
    cv: '34,589 kcl/kg',
  },
  {
    fuel: 'HFO',
    mass: '2380.78 mt',
    sfoc: '2,367 g/kwh',
    cv: '34,589 kcl/kg',
  },
];

export default function ViewNoonReport({ modelOpen, onModelHandleClose, data, voyageDetails}) {
  const formRef = useRef();
  const theme = useTheme();
  const dispatch = useDispatch();

  let source = CancelToken.source();

  const text = theme.palette.primary.text;
  const textLight = theme.palette.primary.textLight;

  const [openAddReport, setOpenAddReport] = useState(false);
  const [details, setDetails] = useState([]);
  const [loading, setLoading] = useState(false);

  const { t } = useTranslation();

  const handleDownload = async (data) => {
    try {
      const response = await fetch(data);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      const name = data?.split('/').pop();
      link.download = `${name}`;
      link.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading image:', error);
    }
  };

  const initApi = async () => {
    await getReportDetails();
  };

  useEffect(() => {
    if (data) {
      initApi();
    }
    return () => {
      if (source) {
        source.cancel();
      }
    };
  }, [data]);

  const getReportDetails = async () => {
    setLoading(true);
    source.cancel();
    source = CancelToken.source();
    const response = await appapi.get(
      `fleet/noonReport/${data?._id}`,
      {},
      {
        cancelToken: source.token,
      },
    );
    if (response.ok) {
      const data = response.data;
      if (data.status === '7400') {
        setDetails(data.response);
      }
      setLoading(false);
    }
  };

  const timeStamp = details?.lastReportDistanceAndTime?.timeStamp && (details?.lastReportDistanceAndTime?.timeStamp).toString();
  const timeStampArray =
    timeStamp?.length > 6
      ? moment(timeStamp)
          .format('HH:mm')
          ?.split(':')
          .reduce((acc, curr) => {
            acc.push(parseInt(curr)); // Convert each character back to a number
            return acc;
          }, [])
      : timeStamp?.split('.').reduce((acc, curr) => {
          acc.push(parseInt(curr)); // Convert each character back to a number
          return acc;
        }, []);

  const meRunningTime = details?.voyageState?.meRunningHours && (details?.voyageState?.meRunningHours).toString();
  const runningTimeArray = meRunningTime?.split('.').reduce((acc, curr) => {
    acc.push(parseInt(curr)); // Convert each character back to a number
    return acc;
  }, []);

  return (
    <Dialog
      sx={sx}
      open={modelOpen}
    >
      <Stack flex={1}>
        <Stack
          direction={'row'}
          alignItems={'center'}
          justifyContent={'space-between'}
          className="sticky top-[0] h-[66px]  bg-white !p-[10px]"
        >
          <Stack
            direction={'row'}
            alignItems={'center'}
          >
            <Typography
              className="fw-medium ff-Roboto fs-14 !ml-[16px] !capitalize"
              color={text}
            >
              {t('Noon report')}
            </Typography>
            <Typography
              className="fw-medium ff-Roboto fs-14 !ml-[160px]"
              color={text}
            >
              {t('Preview')}
            </Typography>
          </Stack>

          <IconButton
            onClick={() => {
              onModelHandleClose(false);
            }}
          >
            <ClearIcon style={{ transform: 'scale(1)', color: '#14285A' }} />
          </IconButton>
        </Stack>
        <Stack
          style={{ backgroundColor: '#8993AC26', width: '100%', height: '2px' }}
          className=""
        />
        {loading && (
          <Stack
            flex={1}
            alignItems={'center'}
            justifyContent={'center'}
          >
            <ActivityIndicator />
          </Stack>
        )}
        {!loading && (
          <Stack className="px-[256px]">
            <Stack
              style={{ backgroundColor: '#F2F3F580', borderRadius: '8px', borderWidth: '1px', borderColor: '#8993AC26' }}
              className="mt-[15px] p-[16px]"
            >
              <Typography
                className="fw-regular ff-Roboto fs-16"
                color={text}
              >
                {t('Basic details')}
              </Typography>
              <Typography
                className="fw-regular ff-Roboto fs-12 !mb-[16px]"
                color={textLight}
              >
                {t('Some info may be visible to other people using ZeroEmission services')}
              </Typography>
              <Stack
                direction={'row'}
                alignItems={'center'}
                flex={1}
              >
                <Stack flex={0.5}>
                  <Stack
                    direction={'row'}
                    alignItems={'center'}
                  >
                    <Typography
                      className="fw-regular ff-Roboto fs-12"
                      color={text}
                    >
                      {t('Voyage no.')}
                    </Typography>
                    <Stack
                      style={{ alignItems: 'center', justifyContent: 'center', backgroundColor: '#00A632' }}
                      className="h-[12px] w-[12px] rounded-[6px] ml-[10px] "
                    >
                      <DoneIcon style={{ color: '#ffffff', transform: 'scale(0.5)' }} />
                    </Stack>
                  </Stack>

                  <Typography
                    className="fw-medium ff-Roboto fs-14 !mt-[6px]"
                    color={text}
                  >
                    {details?.voyageNo || '-'}
                  </Typography>
                </Stack>
                <Stack flex={0.5}>
                  <Stack
                    style={{ backgroundColor: '#003399', borderRadius: '16px', maxWidth: '182px' }}
                    className="py-[8px] px-[12px]"
                  >
                    <Typography
                      color={'#E5F0FF'}
                      className="fw-regular ff-Roboto fs-12"
                      textAlign={'center'}
                    >
                      {t(details?.voyageStatus)}
                    </Typography>
                  </Stack>
                </Stack>
              </Stack>
              <Stack
                direction={'row'}
                alignItems={'center'}
                flex={1}
                className="mt-[20px]"
              >
                <Stack flex={0.5}>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={text}
                  >
                    {t('Report date')} & {t('Time')}
                  </Typography>
                  <Typography
                    className="fw-medium ff-Roboto fs-14 !mt-[6px]"
                    color={text}
                  >
                    {details?.reportDate ? moment(details?.reportDate).tz('utc').format('DD-MMM-YYYY HH:mm') : '-'}
                  </Typography>
                </Stack>
                <Stack flex={0.5}>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={text}
                  >
                    {t('Latitude')} & {t('Longitude')}
                  </Typography>
                  <Typography
                    className="fw-medium ff-Roboto fs-14 !mt-[6px]"
                    color={text}
                  >
                    {details?.latitude}° {details?.latitudeDirection}, {details?.longitude}° {details?.longitudeDirection}
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
            <Stack
              style={{ backgroundColor: '#F2F3F580', borderRadius: '8px', borderWidth: '1px', borderColor: '#8993AC26' }}
              className="mt-[15px] p-[16px]"
            >
              <Typography
                className="fw-regular ff-Roboto fs-16"
                color={text}
              >
                {t('Monitoring data')}
              </Typography>
              <Typography
                className="fw-regular ff-Roboto fs-12 !mb-[16px]"
                color={textLight}
              >
                {t('Some info may be visible to other people using ZeroEmission services')}
              </Typography>
              <Stack
                style={{ backgroundColor: '#8993AC26', width: '100%', height: '1px' }}
                className="mb-[16px]"
              />
              <Typography
                className="fw-regular ff-Roboto fs-14"
                color={text}
              >
                {t('Fuel oil consumption')}
              </Typography>
              <Typography
                className="fw-regular ff-Roboto fs-12 !mb-[16px]"
                color={textLight}
              >
                ({t('From last report')})
              </Typography>
              <Stack style={{ borderWidth: '1px', borderColor: '#8993AC26', borderRadius: '8px' }}>
                <Stack
                  direction={'row'}
                  alignItems={'center'}
                  flex={1}
                  className="p-[16px]"
                >
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={1}
                  >
                    {t('Fuel')}
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={1}
                  >
                    {t('Mass')}
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12 !capi"
                    color={textLight}
                    flex={0.35}
                  >
                    {t('Calorific value')}
                  </Typography>
                </Stack>
                <Stack
                  style={{ backgroundColor: '#8993AC26', width: '100%', height: '1px' }}
                  className=""
                />

                <Stack
                  direction={'row'}
                  alignItems={'center'}
                  flex={1}
                  className="p-[16px]"
                  style={{ backgroundColor: '#FFFFFF' }}
                >
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={1}
                  >
                    HFO
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={1}
                  >
                    {details.fuelConsumption?.hsfo?.mass || '0'} {' mt'}
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.35}
                  >
                    {details.fuelConsumption?.hsfo?.calorificValue || '0'} {details.fuelConsumption?.hsfo?.calorificUnit}
                  </Typography>
                </Stack>
                <Stack
                  direction={'row'}
                  alignItems={'center'}
                  flex={1}
                  className="p-[16px]"
                >
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={1}
                  >
                    MDO
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={1}
                  >
                    {details.fuelConsumption?.mdo?.mass || '0'} {' mt'}
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.35}
                  >
                    {details.fuelConsumption?.mdo?.calorificValue || '0'} {details.fuelConsumption?.mdo?.calorificUnit}
                  </Typography>
                </Stack>
                <Stack
                  direction={'row'}
                  alignItems={'center'}
                  flex={1}
                  className="p-[16px]"
                  style={{ backgroundColor: '#FFFFFF' }}
                >
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={1}
                  >
                    MGO
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={1}
                  >
                    {details.fuelConsumption?.mgo?.mass || '0'} {' mt'}
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.35}
                  >
                    {details.fuelConsumption?.mgo?.calorificValue || '0'} {details.fuelConsumption?.mgo?.calorificUnit}
                  </Typography>
                </Stack>
                <Stack
                  direction={'row'}
                  alignItems={'center'}
                  flex={1}
                  className="p-[16px]"
                >
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={1}
                  >
                    LFO
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={1}
                  >
                    {details.fuelConsumption?.lfo?.mass || '0'} {' mt'}
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.35}
                  >
                    {details.fuelConsumption?.lfo?.calorificValue || '0'} {details.fuelConsumption?.lfo?.calorificUnit}
                  </Typography>
                </Stack>
                <Stack
                  direction={'row'}
                  alignItems={'center'}
                  flex={1}
                  className="p-[16px]"
                  style={{ backgroundColor: '#FFFFFF' }}
                >
                  <Typography
                    className="fw-regular ff-Roboto fs-12 !capitalize"
                    color={textLight}
                    flex={1}
                  >
                    {t('LPG propane')}
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={1}
                  >
                    {details.fuelConsumption?.lpgPropane?.mass || '0'} {' mt'}
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.35}
                  >
                    {details.fuelConsumption?.lpgPropane?.calorificValue || '0'} {details.fuelConsumption?.lpgPropane?.calorificUnit}
                  </Typography>
                </Stack>
                <Stack
                  direction={'row'}
                  alignItems={'center'}
                  flex={1}
                  className="p-[16px]"
                >
                  <Typography
                    className="fw-regular ff-Roboto fs-12 !capitalize"
                    color={textLight}
                    flex={1}
                  >
                    {t('LPG butane')}
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={1}
                  >
                    {details.fuelConsumption?.lpgButane?.mass || '0'} {' mt'}
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.35}
                  >
                    {details.fuelConsumption?.lpgButane?.calorificValue || '0'} {details.fuelConsumption?.lpgButane?.calorificUnit}
                  </Typography>
                </Stack>
                <Stack
                  direction={'row'}
                  alignItems={'center'}
                  flex={1}
                  className="p-[16px]"
                  style={{ backgroundColor: '#FFFFFF' }}
                >
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={1}
                  >
                    LNG
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={1}
                  >
                    {details.fuelConsumption?.lng?.mass || '0'} {' mt'}
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.35}
                  >
                    {details.fuelConsumption?.lng?.calorificValue || '0'} {details.fuelConsumption?.lng?.calorificUnit}
                  </Typography>
                </Stack>
                <Stack
                  direction={'row'}
                  alignItems={'center'}
                  flex={1}
                  className="p-[16px]"
                >
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={1}
                  >
                    {t('Methanol')}
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={1}
                  >
                    {details.fuelConsumption?.methanol?.mass || '0'} {' mt'}
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.35}
                  >
                    {details.fuelConsumption?.methanol?.calorificValue || '0'} {details.fuelConsumption?.methanol?.calorificUnit}
                  </Typography>
                </Stack>
                <Stack
                  direction={'row'}
                  alignItems={'center'}
                  flex={1}
                  className="p-[16px]"
                  style={{ backgroundColor: '#FFFFFF' }}
                >
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={1}
                  >
                    {t('Ethanol')}
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={1}
                  >
                    {details.fuelConsumption?.ethanol?.mass || '0'} {' mt'}
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.35}
                  >
                    {details.fuelConsumption?.ethanol?.calorificValue || '0'} {details.fuelConsumption?.ethanol?.calorificUnit}
                  </Typography>
                </Stack>
                <Stack
                  direction={'row'}
                  alignItems={'center'}
                  flex={1}
                  className="p-[16px]"
                >
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={1}
                  >
                    {t('Others')}
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={1}
                  >
                    {details.fuelConsumption?.others?.mass || '0'} {' mt'}
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.35}
                  >
                    {details.fuelConsumption?.others?.calorificValue || '0'} {details.fuelConsumption?.others?.calorificUnit}
                  </Typography>
                </Stack>
              </Stack>
              <Stack
                style={{ backgroundColor: '#8993AC26', width: '100%', height: '1px' }}
                className="my-[20px]"
              />
              <Typography
                className="fw-regular ff-Roboto fs-14"
                color={text}
              >
                {t('Distance and time')}
              </Typography>
              <Typography
                className="fw-regular ff-Roboto fs-12 !mb-[16px]"
                color={textLight}
              >
                ({t('From last report')})
              </Typography>
              <Stack
                direction={'row'}
                alignItems={'center'}
                flex={1}
                className="mt-[4px]"
              >
                <Stack
                  flex={0.75}
                  direction={'row'}
                >
                  <Stack flex={0.333}>
                    <Typography
                      className="fw-regular ff-Roboto fs-12"
                      color={text}
                    >
                      {t('Hours')}
                    </Typography>
                    <Typography
                      className="fw-medium ff-Roboto fs-14 !mt-[6px]"
                      color={text}
                    >
                      {details?.lastReportDistanceAndTime?.timeStamp ? timeStampArray[0] : '-'} {details?.lastReportDistanceAndTime?.timeStamp ? t('Hours') :  null}
                    </Typography>
                  </Stack>
                  <Stack flex={0.333}>
                    <Typography
                      className="fw-regular ff-Roboto fs-12"
                      color={text}
                    >
                      {t('Minutes')}
                    </Typography>
                    <Typography
                      className="fw-medium ff-Roboto fs-14 !mt-[6px]"
                      color={text}
                    >
                      {details?.lastReportDistanceAndTime?.timeStamp ? timeStampArray[1] : '-'} {details?.lastReportDistanceAndTime?.timeStamp ? t('Minutes') :  null}
                    </Typography>
                  </Stack>
                  <Stack flex={0.333}>
                    <Typography
                      className="fw-regular ff-Roboto fs-12"
                      color={text}
                    >
                      {t('Heading')}
                    </Typography>
                    <Typography
                      className="fw-medium ff-Roboto fs-14 !mt-[6px]"
                      color={text}
                    >
                      {(details?.lastReportDistanceAndTime?.heading && details?.lastReportDistanceAndTime?.heading + ' deg') || '0 deg'}
                    </Typography>
                  </Stack>
                </Stack>
                <Stack flex={0.25}>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={text}
                  >
                    {t('Distance')}
                  </Typography>
                  <Typography
                    className="fw-medium ff-Roboto fs-14 !mt-[6px]"
                    color={text}
                  >
                    {(details?.lastReportDistanceAndTime?.distance && details?.lastReportDistanceAndTime?.distance + ' nm') || '0 nm'}
                  </Typography>
                </Stack>
              </Stack>
              <Stack
                direction={'row'}
                alignItems={'center'}
                flex={1}
                className="mt-[20px]"
              >
                <Stack flex={0.5}>
                  <Typography
                    className="fw-regular ff-Roboto fs-12 !capitalize"
                    color={text}
                  >
                    {t('Average speed (ground)')}
                  </Typography>
                  <Typography
                    className="fw-medium ff-Roboto fs-14 !mt-[6px]"
                    color={text}
                  >
                    {(details?.lastReportDistanceAndTime?.averageSpeedOfGround && details?.lastReportDistanceAndTime?.averageSpeedOfGround + ' kts') || '0'}
                  </Typography>
                </Stack>
                <Stack flex={0.5}>
                  <Typography
                    className="fw-regular ff-Roboto fs-12 !capitalize"
                    color={text}
                  >
                    {t('Average speed (water)')}
                  </Typography>
                  <Typography
                    className="fw-medium ff-Roboto fs-14 !mt-[6px]"
                    color={text}
                  >
                    {(details?.lastReportDistanceAndTime?.averageSpeedOfWater && details?.lastReportDistanceAndTime?.averageSpeedOfWater + ' kts') || '0'}
                  </Typography>
                </Stack>
              </Stack>
              <Stack
                style={{ backgroundColor: '#8993AC26', width: '100%', height: '1px' }}
                className="my-[20px]"
              />
              <Typography
                className="fw-regular ff-Roboto fs-14 !capitalize"
                color={text}
              >
                {t('Voyage state')}
              </Typography>
              <Stack
                direction={'row'}
                alignItems={'center'}
                flex={1}
                className="mt-[20px]"
              >
                <Stack flex={0.5}>
                  <Typography
                    className="fw-regular ff-Roboto fs-12 !capitalize"
                    color={text}
                  >
                    {t('Propeller revolution')}
                  </Typography>
                  <Typography
                    className="fw-medium ff-Roboto fs-14 !mt-[6px]"
                    color={text}
                  >
                    {details?.voyageState?.propellerRevolution || '0'} rpm
                  </Typography>
                </Stack>
                <Stack flex={0.5}>
                  <Typography
                    className="fw-regular ff-Roboto fs-12 !capitalize"
                    color={text}
                  >
                    {t('Specific Fuel Oil Consumption')}
                  </Typography>
                  <Typography
                    className="fw-medium ff-Roboto fs-14 !mt-[6px]"
                    color={text}
                  >
                    {details?.voyageState?.sfoc || '0'} {details?.voyageState?.sfocUnit}
                  </Typography>
                </Stack>
              </Stack>
              <Stack
                direction={'row'}
                alignItems={'center'}
                flex={1}
                className="mt-[20px]"
              >
                <Stack flex={0.5}>
                  <Typography
                    className="fw-regular ff-Roboto fs-12 !capitalize"
                    color={text}
                  >
                    {t('ME Running Hours')}
                  </Typography>
                  <Stack
                    direction={'row'}
                    alignItems={'center'}
                  >
                    <Typography
                      className="fw-medium ff-Roboto fs-14 !mt-[6px]"
                      color={text}
                      flex={0.5}
                    >
                      {details?.voyageState?.meRunningHours ? runningTimeArray[0] : '0'} {t('Hours')}
                    </Typography>
                    <Typography
                      className="fw-medium ff-Roboto fs-14 !mt-[6px]"
                      color={text}
                      flex={0.5}
                    >
                      {details?.voyageState?.meRunningHours ? runningTimeArray[1] : '0'} {t('Minutes')}
                    </Typography>
                  </Stack>
                </Stack>
                <Stack flex={0.25}>
                  <Typography
                    className="fw-regular ff-Roboto fs-12 !capitalize"
                    color={text}
                  >
                    {t('Average ME output')}
                  </Typography>
                  <Typography
                    className="fw-medium ff-Roboto fs-14 !mt-[6px]"
                    color={text}
                  >
                    {details?.voyageState?.averageMEOutput || '0'} kw
                  </Typography>
                </Stack>
                <Stack flex={0.25}>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={text}
                  >
                    {t('Sea state')}
                  </Typography>
                  <Typography
                    className="fw-medium ff-Roboto fs-14 !mt-[6px]"
                    color={text}
                  >
                    {details?.voyageState?.seaState || '0'}
                  </Typography>
                </Stack>
              </Stack>
              <Stack
                style={{ backgroundColor: '#8993AC26', width: '100%', height: '1px' }}
                className="my-[20px]"
              />
              <Typography
                className="fw-regular ff-Roboto fs-14 !capitalize"
                color={text}
              >
                {t('Port Information (Arrival)')}
              </Typography>
              <Stack
                direction={'row'}
                alignItems={'center'}
                flex={1}
                className="mt-[20px]"
              >
                <Stack flex={0.5}>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={text}
                  >
                    {t('Port name')}
                  </Typography>
                  <Typography
                    className="fw-medium ff-Roboto fs-14 !mt-[6px]"
                    color={text}
                  >
                    {details?.portInformation?.portName || '-'}
                  </Typography>
                </Stack>
                <Stack flex={0.5}>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={text}
                  >
                    {t('UNLOC')}
                  </Typography>
                  <Typography
                    className="fw-medium ff-Roboto fs-14 !mt-[6px]"
                    color={text}
                  >
                    {details?.portInformation?.unloc || '-'}
                  </Typography>
                </Stack>
              </Stack>
              <Stack
                direction={'row'}
                alignItems={'center'}
                flex={1}
                className="mt-[20px]"
              >
                <Stack flex={0.5}>
                  <Typography
                    className="fw-regular ff-Roboto fs-12 !capitalize"
                    color={text}
                  >
                    {t('EU port')}
                  </Typography>
                  <Typography
                    className="fw-medium ff-Roboto fs-14 !mt-[6px]"
                    color={text}
                  >
                    {details?.portInformation?.isEuPort ? 'Yes' : 'No' || '-'}
                  </Typography>
                </Stack>
                <Stack flex={0.5}>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={text}
                  >
                    {t('Port Loading / Unloading')}
                  </Typography>
                  <Typography
                    className="fw-medium ff-Roboto fs-14 !mt-[6px]"
                    color={text}
                  >
                    {details?.portInformation?.isPortLoadingOrUnloading ? 'Yes' : 'No'}
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
            <Stack
              style={{ backgroundColor: '#F2F3F580', borderRadius: '8px', borderWidth: '1px', borderColor: '#8993AC26' }}
              className="mt-[15px] p-[16px]"
            >
              <Stack
                direction={'row'}
                alignItems={'center'}
              >
                <Typography
                  className="fw-regular ff-Roboto fs-16"
                  color={text}
                >
                  {t('Bunkered')}
                </Typography>
                {/* <Stack
                  style={{ alignItems: 'center', justifyContent: 'center', backgroundColor: '#00A632' }}
                  className="h-[12px] w-[12px] rounded-[6px] ml-[10px] "
                >
                  <DoneIcon style={{ color: '#ffffff', transform: 'scale(0.5)' }} />
                </Stack> */}
              </Stack>

              <Typography
                className="fw-regular ff-Roboto fs-12 !mb-[16px]"
                color={textLight}
              >
                {t('Some info may be visible to other people using ZeroEmission services')}
              </Typography>
              {details?.bunkered?.bunkeredDeliveryNote && (
                <>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={text}
                  >
                    {t('Bunkered Delivery Notes')}
                  </Typography>

                  <Stack
                    onClick={() => handleDownload(details?.bunkered?.bunkeredDeliveryNote)}
                    style={{ cursor: 'pointer' }}
                  >
                    <Typography
                      color={'#006DFF'}
                      className="fw-regular ff-Roboto fs-16 !mb-[16px] !uppercase"
                    >
                      {t('Download')}
                    </Typography>
                  </Stack>
                </>
              )}

              <Stack style={{ borderWidth: '1px', borderColor: '#8993AC26', borderRadius: '8px' }}>
                <Stack
                  direction={'row'}
                  alignItems={'center'}
                  flex={1}
                  className="p-[16px]"
                >
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.25}
                  >
                    {t('Fuel')}
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.25}
                  >
                    {t('Mass')}
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.25}
                  >
                    {t('Volume')}
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.25}
                  >
                    {t('Density')}
                  </Typography>
                </Stack>
                <Stack
                  style={{ backgroundColor: '#8993AC26', width: '100%', height: '1px' }}
                  className=""
                />

                <Stack
                  direction={'row'}
                  alignItems={'center'}
                  flex={1}
                  className="p-[16px]"
                  style={{ backgroundColor: '#FFFFFF' }}
                >
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.25}
                  >
                    HFO{' '}
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.25}
                  >
                    {details?.bunkered?.hsfo?.mass || '0'} {' mt'}
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.25}
                  >
                    {details?.bunkered?.hsfo?.volume || '0'} {' g/kwh'}
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.25}
                  >
                    {details?.bunkered?.hsfo?.density || '0'} {'kcal/kg'}
                  </Typography>
                </Stack>
                <Stack
                  direction={'row'}
                  alignItems={'center'}
                  flex={1}
                  className="p-[16px]"
                  // style={{backgroundColor:}}
                >
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.25}
                  >
                    MDO{' '}
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.25}
                  >
                    {details?.bunkered?.mdo?.mass || '0'} {' mt'}
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.25}
                  >
                    {details?.bunkered?.mdo?.volume || '0'} {' g/kwh'}
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.25}
                  >
                    {details?.bunkered?.mdo?.density || '0'} {'kcal/kg'}
                  </Typography>
                </Stack>
                <Stack
                  direction={'row'}
                  alignItems={'center'}
                  flex={1}
                  className="p-[16px]"
                  style={{ backgroundColor: '#FFFFFF' }}
                >
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.25}
                  >
                    MGO{' '}
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.25}
                  >
                    {details?.bunkered?.mgo?.mass || '0'} {' mt'}
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.25}
                  >
                    {details?.bunkered?.mgo?.volume || '0'} {' g/kwh'}
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.25}
                  >
                    {details?.bunkered?.mgo?.density || '0'} {'kcal/kg'}
                  </Typography>
                </Stack>
                <Stack
                  direction={'row'}
                  alignItems={'center'}
                  flex={1}
                  className="p-[16px]"
                >
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.25}
                  >
                    LFO{' '}
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.25}
                  >
                    {details?.bunkered?.lfo?.mass || '0'} {' mt'}
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.25}
                  >
                    {details?.bunkered?.lfo?.volume || '0'} {' g/kwh'}
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.25}
                  >
                    {details?.bunkered?.lfo?.density || '0'} {'kcal/kg'}
                  </Typography>
                </Stack>
                <Stack
                  direction={'row'}
                  alignItems={'center'}
                  flex={1}
                  className="p-[16px]"
                  style={{ backgroundColor: '#FFFFFF' }}
                >
                  <Typography
                    className="fw-regular ff-Roboto fs-12 !capitalize"
                    color={textLight}
                    flex={0.25}
                  >
                    {t('LPG propane')}{' '}
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.25}
                  >
                    {details?.bunkered?.lpgPropane?.mass || '0'} {' mt'}
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.25}
                  >
                    {details?.bunkered?.lpgPropane?.volume || '0'} {' g/kwh'}
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.25}
                  >
                    {details?.bunkered?.lpgPropane?.density || '0'} {'kcal/kg'}
                  </Typography>
                </Stack>
                <Stack
                  direction={'row'}
                  alignItems={'center'}
                  flex={1}
                  className="p-[16px]"
                >
                  <Typography
                    className="fw-regular ff-Roboto fs-12 !capitalize"
                    color={textLight}
                    flex={0.25}
                  >
                    {t('LPG butane')}{' '}
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.25}
                  >
                    {details?.bunkered?.lpgButane?.mass || '0'} {' mt'}
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.25}
                  >
                    {details?.bunkered?.lpgButane?.volume || '0'} {' g/kwh'}
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.25}
                  >
                    {details?.bunkered?.lpgButane?.density || '0'} {'kcal/kg'}
                  </Typography>
                </Stack>
                <Stack
                  direction={'row'}
                  alignItems={'center'}
                  flex={1}
                  className="p-[16px]"
                  style={{ backgroundColor: '#FFFFFF' }}
                >
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.25}
                  >
                    LNG{' '}
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.25}
                  >
                    {details?.bunkered?.lng?.mass || '0'} {' mt'}
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.25}
                  >
                    {details?.bunkered?.lng?.volume || '0'} {' g/kwh'}
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.25}
                  >
                    {details?.bunkered?.lng?.density || '0'} {'kcal/kg'}
                  </Typography>
                </Stack>
                <Stack
                  direction={'row'}
                  alignItems={'center'}
                  flex={1}
                  className="p-[16px]"
                >
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.25}
                  >
                    {t('Methanol')}{' '}
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.25}
                  >
                    {details?.bunkered?.methanol?.mass || '0'} {' mt'}
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.25}
                  >
                    {details?.bunkered?.methanol?.volume || '0'} {' g/kwh'}
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.25}
                  >
                    {details?.bunkered?.methanol?.density || '0'} {'kcal/kg'}
                  </Typography>
                </Stack>
                <Stack
                  direction={'row'}
                  alignItems={'center'}
                  flex={1}
                  className="p-[16px]"
                  style={{ backgroundColor: '#FFFFFF' }}
                >
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.25}
                  >
                    {t('Ethanol')}{' '}
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.25}
                  >
                    {details?.bunkered?.ethanol?.mass || '0'} {' mt'}
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.25}
                  >
                    {details?.bunkered?.ethanol?.volume || '0'} {' g/kwh'}
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.25}
                  >
                    {details?.bunkered?.ethanol?.density || '0'} {'kcal/kg'}
                  </Typography>
                </Stack>
                <Stack
                  direction={'row'}
                  alignItems={'center'}
                  flex={1}
                  className="p-[16px]"
                >
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.25}
                  >
                    {t('Others')}{' '}
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.25}
                  >
                    {details?.bunkered?.others?.mass || '0'} {' mt'}
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.25}
                  >
                    {details?.bunkered?.others?.volume || '0'} {' g/kwh'}
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.25}
                  >
                    {details?.bunkered?.others?.density || '0'} {'kcal/kg'}
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
            <Stack
              style={{ backgroundColor: '#F2F3F580', borderRadius: '8px', borderWidth: '1px', borderColor: '#8993AC26' }}
              className="mt-[15px] p-[16px]"
            >
              <Typography
                className="fw-regular ff-Roboto fs-16"
                color={text}
              >
                {t('Cargo')}
              </Typography>
              <Typography
                className="fw-regular ff-Roboto fs-12 !mb-[16px]"
                color={textLight}
              >
                {t('Some info may be visible to other people using ZeroEmission services')}
              </Typography>

              <Stack
                direction={'row'}
                alignItems={'center'}
                flex={1}
                className="mt-[16px]"
              >
                {details?.cargo?.billOfLoading && (
                  <>
                    <Stack flex={0.5}>
                      <Typography
                        className="fw-regular ff-Roboto fs-12"
                        color={text}
                      >
                        {t('Bill of Loading')}
                      </Typography>

                      <Stack
                        onClick={() => handleDownload(details?.cargo?.billOfLoading)}
                        style={{ cursor: 'poonter' }}
                      >
                        <Typography
                          color={'#006DFF'}
                          className="fw-regular ff-Roboto fs- !uppercase"
                        >
                          {t('Download')}
                        </Typography>
                      </Stack>
                    </Stack>
                  </>
                )}
                <Stack flex={0.5}>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={text}
                  >
                    {t('Cargo Carried')}
                  </Typography>
                  <Typography
                    className="fw-medium ff-Roboto fs-14 !mt-[6px]"
                    color={text}
                  >
                    {details?.cargo?.cargoCarried || '0'} mt
                  </Typography>
                </Stack>
                <Stack flex={0.5}>
                  <Typography
                    className="fw-regular ff-Roboto fs-12 !capitalize"
                    color={text}
                  >
                    {t('Ship condition')}
                  </Typography>
                  <Typography
                    className="fw-medium ff-Roboto fs-14 !mt-[6px] !capitalize"
                    color={text}
                  >
                    {t(details?.cargo?.loadingCondition) || '0'}
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
            <Stack
              style={{ backgroundColor: '#F2F3F580', borderRadius: '8px', borderWidth: '1px', borderColor: '#8993AC26' }}
              className="mt-[15px] p-[16px]"
            >
              <Typography
                className="fw-regular ff-Roboto fs-16 !capitalize"
                color={text}
              >
                {t('Remaining onboard')}
              </Typography>
              <Typography
                className="fw-regular ff-Roboto fs-12 !mb-[16px]"
                color={textLight}
              >
                {t('Some info may be visible to other people using ZeroEmission services')}
              </Typography>
              <Stack style={{ borderWidth: '1px', borderColor: '#8993AC26', borderRadius: '8px' }}>
                <Stack
                  direction={'row'}
                  alignItems={'center'}
                  flex={1}
                  className="p-[16px]"
                >
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.5}
                  >
                    {t('Fuel')}
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.5}
                  >
                    {t('Mass')}
                  </Typography>
                </Stack>
                <Stack
                  style={{ backgroundColor: '#8993AC26', width: '100%', height: '1px' }}
                  className=""
                />

                <Stack
                  direction={'row'}
                  alignItems={'center'}
                  flex={1}
                  className="p-[16px]"
                  style={{ backgroundColor: '#FFFFFF' }}
                >
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.5}
                  >
                    HFO
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.5}
                  >
                    {details?.remaingOnBoard?.hsfo || '0'} {' mt'}
                  </Typography>
                </Stack>
                <Stack
                  direction={'row'}
                  alignItems={'center'}
                  flex={1}
                  className="p-[16px]"
                >
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.5}
                  >
                    MDO
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.5}
                  >
                    {details?.remaingOnBoard?.mdo || '0'} {' mt'}
                  </Typography>
                </Stack>
                <Stack
                  direction={'row'}
                  alignItems={'center'}
                  flex={1}
                  className="p-[16px]"
                  style={{ backgroundColor: '#FFFFFF' }}
                >
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.5}
                  >
                    MGO
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.5}
                  >
                    {details?.remaingOnBoard?.mgo || '0'} {' mt'}
                  </Typography>
                </Stack>
                <Stack
                  direction={'row'}
                  alignItems={'center'}
                  flex={1}
                  className="p-[16px]"
                >
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.5}
                  >
                    LFO
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.5}
                  >
                    {details?.remaingOnBoard?.lfo || '0'} {' mt'}
                  </Typography>
                </Stack>
                <Stack
                  direction={'row'}
                  alignItems={'center'}
                  flex={1}
                  className="p-[16px]"
                  style={{ backgroundColor: '#FFFFFF' }}
                >
                  <Typography
                    className="fw-regular ff-Roboto fs-12 !capitalize"
                    color={textLight}
                    flex={0.5}
                  >
                    {t('LPG propane')}
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.5}
                  >
                    {details?.remaingOnBoard?.lpgPropane || '0'} {' mt'}
                  </Typography>
                </Stack>
                <Stack
                  direction={'row'}
                  alignItems={'center'}
                  flex={1}
                  className="p-[16px]"
                >
                  <Typography
                    className="fw-regular ff-Roboto fs-12 !capitalize"
                    color={textLight}
                    flex={0.5}
                  >
                    {t('LPG butane')}
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.5}
                  >
                    {details?.remaingOnBoard?.lpgButane || '0'} {' mt'}
                  </Typography>
                </Stack>
                <Stack
                  direction={'row'}
                  alignItems={'center'}
                  flex={1}
                  className="p-[16px]"
                  style={{ backgroundColor: '#FFFFFF' }}
                >
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.5}
                  >
                    LNG
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.5}
                  >
                    {details?.remaingOnBoard?.lng || '0'} {' mt'}
                  </Typography>
                </Stack>
                <Stack
                  direction={'row'}
                  alignItems={'center'}
                  flex={1}
                  className="p-[16px]"
                >
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.5}
                  >
                    {t('Methanol')}
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.5}
                  >
                    {details?.remaingOnBoard?.methanol || '0'} {' mt'}
                  </Typography>
                </Stack>
                <Stack
                  direction={'row'}
                  alignItems={'center'}
                  flex={1}
                  className="p-[16px]"
                  style={{ backgroundColor: '#FFFFFF' }}
                >
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.5}
                  >
                    {t('Ethanol')}
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.5}
                  >
                    {details?.remaingOnBoard?.ethanol || '0'} {' mt'}
                  </Typography>
                </Stack>
                <Stack
                  direction={'row'}
                  alignItems={'center'}
                  flex={1}
                  className="p-[16px]"
                >
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.5}
                  >
                    {t('Others')}
                  </Typography>
                  <Typography
                    className="fw-regular ff-Roboto fs-12"
                    color={textLight}
                    flex={0.5}
                  >
                    {details?.remaingOnBoard?.others || '0'} {' mt'}
                  </Typography>
                </Stack>
              </Stack>
            </Stack>
            <DialogActions
              className="!mt-[44px] h-[66px] !justify-end p-[0px] sticky bottom-[0]"
              style={{ backgroundColor: '#FFFFFF', zIndex: 1 }}
            >
              <Button
                sx={{
                  border: 1,
                  margin: '10px',
                  color: theme.palette.primary.text,
                  borderColor: '#14285A4D',
                  backgroundColor: '#FFFFFF',
                  textTransform: 'uppercase',
                  '&:hover': {
                    borderColor: '#14285A4D',
                    backgroundColor: '#FFFFFF',
                    borderColor: '#14285A4D',
                  },
                }}
                style={buttonStyle2}
                variant="contained"
                // style={{ width: '128px', marginLeft: '80px', height: '40px', borderColor: '#14285A4D' }}
                onClick={() => {
                  setOpenAddReport(true);
                }}
              >
                {t('Edit details')}
              </Button>
            </DialogActions>
          </Stack>
        )}
      </Stack>
      {openAddReport && (
        <AddNoonReport
          modelOpen={openAddReport}
          onModelHandleClose={(event) => {
            if (event) {
              setOpenAddReport(false);
              getReportDetails();
            }
            setOpenAddReport(false);
          }}
          voyageDetails={voyageDetails}
          data={details}
        />
      )}
    </Dialog>
  );
}
